/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const searchContentResponseDataContentSearchContentGraphContentNodesItemTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax = 8;

export const searchContentResponseDataContentSearchContentGraphContentNodesItemTypeDefinitionReferenceViewPredicatesMax = 10;

export const searchContentResponseDataContentSearchContentGraphContentNodesItemTypeDefinitionReferenceViewSearchTermsItemMax = 200;

export const searchContentResponseDataContentSearchContentGraphContentNodesItemTypeDefinitionReferenceViewSearchTermsMax = 10;

export const searchContentResponseDataContentSearchHitsItemOneTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax = 8;

export const searchContentResponseDataContentSearchHitsItemOneTypeDefinitionReferenceViewPredicatesMax = 10;

export const searchContentResponseDataContentSearchHitsItemOneTypeDefinitionReferenceViewSearchTermsItemMax = 200;

export const searchContentResponseDataContentSearchHitsItemOneTypeDefinitionReferenceViewSearchTermsMax = 10;

export const SearchContentResponse = zod.object({
  data: zod.object({
    contentSearch: zod.object({
      contentGraph: zod.object({
        actors: zod.array(
          zod.object({
            actorType: zod.enum(['USER', 'SYSTEM', 'GROUP', 'PUBLIC', 'AGENT']),
            firstName: zod.string().nullable(),
            id: zod.string().nullable(),
            lastName: zod.string().nullable(),
            name: zod.string(),
            profileImage: zod
              .object({
                large: zod
                  .object({
                    contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
                    url: zod.string().nullable(),
                  })
                  .nullable(),
                medium: zod
                  .object({
                    contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
                    url: zod.string().nullable(),
                  })
                  .nullable(),
                original: zod
                  .object({
                    contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
                    url: zod.string().nullable(),
                  })
                  .nullable(),
                small: zod
                  .object({
                    contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
                    url: zod.string().nullable(),
                  })
                  .nullable(),
                xsmall: zod
                  .object({
                    contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
                    url: zod.string().nullable(),
                  })
                  .nullable(),
              })
              .nullable(),
            uuid: zod.uuid().describe('UUID v4 identifier'),
          }),
        ),
        contentActorEdges: zod.array(
          zod.object({
            audience: zod.object({
              principalType: zod.enum([
                'USER',
                'GROUP',
                'GROUP_MEMBERS',
                'GROUP_MEMBER',
                'PUBLIC',
                'SYSTEM',
                'AGENT',
              ]),
              scopeUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
              uuid: zod.uuid().describe('UUID v4 identifier'),
            }),
            contentUuid: zod.uuid().describe('UUID v4 identifier'),
            createdAt: zod.string(),
            creator: zod.object({
              principalType: zod.enum(['USER', 'GROUP', 'GROUP_MEMBER', 'SYSTEM', 'AGENT']),
              scopeUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
              uuid: zod.uuid().describe('UUID v4 identifier'),
            }),
            edgeType: zod.enum(['AUTHORED_BY', 'SHARED_WITH']),
            expiry: zod.string().nullable(),
            permissions: zod
              .array(zod.enum(['READ', 'SHARE', 'COPY', 'CONTRIBUTE', 'EDIT', 'DELETE']))
              .describe(
                'Permissions this audience holds on this ONE node. Per node and per audience — never a summary of what the reader may do to the graph.',
              ),
            updatedAt: zod.string(),
          }),
        ),
        contentEdges: zod.array(
          zod.object({
            carbonCopy: zod.boolean(),
            certainty: zod.enum(['ASSERTED', 'INFERRED', 'SUGGESTED']),
            creator: zod.object({
              principalType: zod.enum(['USER', 'GROUP', 'GROUP_MEMBER', 'SYSTEM', 'AGENT']),
              scopeUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
              uuid: zod.uuid().describe('UUID v4 identifier'),
            }),
            edgeDescription: zod
              .string()
              .nullable()
              .describe(
                'Authored edge text, returned verbatim including an explicit empty string.',
              ),
            edgeKey: zod
              .string()
              .nullable()
              .describe(
                'Schema slot key on a TYPE→TYPE declaration; null on an ordinary relationship. An empty string is a stored value, not an absence.',
              ),
            edgeType: zod.enum(['CONTAINS', 'RELATES_TO', 'INCLUDES']),
            fromLineageUuid: zod.uuid().describe('UUID v4 identifier'),
            fromUuid: zod.uuid().describe('UUID v4 identifier'),
            maxCount: zod.int().nullable(),
            minCount: zod.int().nullable(),
            position: zod.int().nullable(),
            toLineageUuid: zod.uuid().describe('UUID v4 identifier'),
            toUuid: zod.uuid().describe('UUID v4 identifier'),
          }),
        ),
        contentNodes: zod
          .array(
            zod.object({
              authors: zod
                .array(
                  zod.object({
                    principalType: zod
                      .enum(['USER', 'GROUP', 'GROUP_MEMBER', 'AGENT'])
                      .describe(
                        'USER: a person, as themselves. GROUP: a group acting as itself. GROUP_MEMBER: a person as a member of the group in scopeUuid. AGENT: an agent — with scopeUuid, writing for that user under their delegation.',
                      ),
                    principalUuid: zod
                      .uuid()
                      .describe(
                        'The author: a user, group or agent actor (a GROUP_MEMBER is the user).',
                      ),
                    roles: zod
                      .array(zod.enum(['AUTHOR', 'ON_BEHALF_OF']))
                      .describe(
                        'AUTHOR: wrote some version of this content or of something it contains. ON_BEHALF_OF: an agent that wrote for the user in scopeUuid, under their delegation. Only what is recorded — nothing is inferred.',
                      ),
                    scopeUuid: zod
                      .uuid()
                      .nullable()
                      .describe(
                        'The group a GROUP_MEMBER wrote as a member of, or the user an AGENT wrote for. Null otherwise.',
                      ),
                  }),
                )
                .nullable()
                .describe(
                  'Who wrote this content: every author of any version of it or of anything it currently CONTAINS, as far as the reader can read — whatever depth was hydrated — in the order they first wrote. Set on the roots of a read (the requested lineage, each feed item, each search hit); null on every other node. Names are in `actors`.',
                ),
              contentTypeUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
              contributors: zod
                .object({
                  nodes: zod.array(
                    zod.object({
                      actorType: zod.enum(['USER', 'SYSTEM', 'GROUP', 'PUBLIC', 'AGENT']),
                      firstName: zod.string().nullable(),
                      id: zod.string().nullable(),
                      lastName: zod.string().nullable(),
                      name: zod.string(),
                      profileImage: zod
                        .object({
                          large: zod
                            .object({
                              contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
                              url: zod.string().nullable(),
                            })
                            .nullable(),
                          medium: zod
                            .object({
                              contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
                              url: zod.string().nullable(),
                            })
                            .nullable(),
                          original: zod
                            .object({
                              contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
                              url: zod.string().nullable(),
                            })
                            .nullable(),
                          small: zod
                            .object({
                              contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
                              url: zod.string().nullable(),
                            })
                            .nullable(),
                          xsmall: zod
                            .object({
                              contentUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
                              url: zod.string().nullable(),
                            })
                            .nullable(),
                        })
                        .nullable(),
                      uuid: zod.uuid().describe('UUID v4 identifier'),
                    }),
                  ),
                  totalCount: zod.int(),
                })
                .describe(
                  'Deprecated: use `authors`. Every actor with an edge on this one node — share recipients included — deduplicated by uuid alone.',
                ),
              createdAt: zod.string(),
              grants: zod.object({
                totalCount: zod.int(),
              }),
              lineageUuid: zod.uuid().describe('Stable identity across versions.'),
              occurredAt: zod.string(),
              outgoingRevision: zod
                .string()
                .describe(
                  'Opaque revision of this node’s outgoing edges and TYPE policy state. Send it back as `expectedOutgoingRevision` on a mutate command to refuse a write whose source has changed since this read. It is NOT the node version: an edge-only change — a field added, a body reordered, a slot retargeted, a cardinality or edgeKey edited — does not version its source, so `uuid` alone cannot guard against it. Computed over the complete stored graph under the same locks as the mutation, so a reader who cannot see every child still gets a comparable value. Treat it as opaque; its format may change.',
                ),
              prevVersionUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
              subjectUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
              typeDefinition: zod
                .object({
                  conformance: zod.enum(['open', 'lax', 'strict']).optional(),
                  description: zod.string().nullish(),
                  enums: zod
                    .array(
                      zod.object({
                        label: zod.string(),
                        value: zod.string(),
                      }),
                    )
                    .nullish(),
                  file: zod
                    .object({
                      allowedFormats: zod
                        .array(
                          zod.enum([
                            'pdf',
                            'doc',
                            'docx',
                            'xls',
                            'xlsx',
                            'csv',
                            'txt',
                            'jpeg',
                            'png',
                            'webp',
                            'gif',
                            'heic',
                            'md',
                            'html',
                            'mp3',
                            'm4a',
                            'wav',
                            'mp4',
                            'mov',
                            'webm',
                          ]),
                        )
                        .min(1)
                        .optional(),
                    })
                    .nullish(),
                  metadata: zod.record(zod.string(), zod.unknown()).nullish(),
                  reference: zod
                    .object({
                      carbonCopy: zod.boolean().optional(),
                      creation: zod.enum(['forbidden', 'optional', 'required']).optional(),
                      edgeType: zod.enum(['INCLUDES', 'RELATES_TO']).optional(),
                      typeLineageUuid: zod.uuid(),
                      typeUuid: zod.uuid(),
                      view: zod
                        .object({
                          predicates: zod
                            .array(
                              zod.object({
                                op: zod.enum(['exists', 'eq', 'contains', 'gte', 'lte']),
                                pathTypeUuids: zod
                                  .array(zod.uuid())
                                  .min(1)
                                  .max(
                                    searchContentResponseDataContentSearchContentGraphContentNodesItemTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax,
                                  ),
                                value: zod.string().optional(),
                                valueType: zod
                                  .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
                                  .optional(),
                              }),
                            )
                            .max(
                              searchContentResponseDataContentSearchContentGraphContentNodesItemTypeDefinitionReferenceViewPredicatesMax,
                            )
                            .optional(),
                          searchTerms: zod
                            .array(
                              zod
                                .string()
                                .min(1)
                                .max(
                                  searchContentResponseDataContentSearchContentGraphContentNodesItemTypeDefinitionReferenceViewSearchTermsItemMax,
                                ),
                            )
                            .max(
                              searchContentResponseDataContentSearchContentGraphContentNodesItemTypeDefinitionReferenceViewSearchTermsMax,
                            )
                            .optional(),
                        })
                        .nullish(),
                    })
                    .nullish(),
                  signature: zod.looseObject({}).nullish(),
                })
                .nullable()
                .describe(
                  'Stored TYPE configuration: description, arbitrary metadata, ENUM value\/label pairs, and the reference \/ file \/ signature field bags.',
                ),
              typeName: zod.string().nullable(),
              updatedAt: zod.string(),
              uuid: zod.uuid().describe('This exact version. Edits address this UUID.'),
              value: zod
                .object({
                  booleanValue: zod.boolean().nullish(),
                  dateValue: zod.string().nullish(),
                  datetimeValue: zod.string().nullish(),
                  jsonValue: zod
                    .unknown()
                    .optional()
                    .describe(
                      'Native JSON for `valueType: JSON` — arrays, objects and scalars are returned exactly as stored.',
                    ),
                  numericValue: zod.number().nullish(),
                  stringValue: zod.string().nullish(),
                })
                .nullable(),
              valueType: zod
                .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME', 'ENUM', 'JSON'])
                .nullable(),
              variant: zod.enum(['TYPE', 'INSTANCE']),
              viewerPermissions: zod
                .array(zod.enum(['READ', 'SHARE', 'COPY', 'CONTRIBUTE', 'EDIT', 'DELETE']))
                .nullable()
                .describe(
                  'What the reader, in the acting context of this read (viewAs), may do to this node: READ plus each write permission the write paths would grant — inherited grants included — for gating Share, Edit and Delete. Set on GET \/content\/{lineageUuid} for every traversed node; null on referenced-only TYPE rows and on feed and search reads. It never overstates: a share link or an agent carve-out may allow more.',
                ),
            }),
          )
          .describe(
            'Traversed nodes plus complete referenced TYPE rows, including soft-deleted types. Use traversedNodeUuids to distinguish traversal membership.',
          ),
        traversedNodeUuids: zod
          .array(zod.uuid().describe('UUID v4 identifier'))
          .describe(
            'Exact versions reached by the permission-filtered traversal. Referenced-only TYPE rows are excluded; their presence grants no traversal membership or permissions.',
          ),
      }),
      hits: zod.array(
        zod.union([
          zod.object({
            constantCount: zod
              .int()
              .describe('Constants and body data: TYPE→INSTANCE edges over CONTAINS or INCLUDES'),
            createdAt: zod.string(),
            cursor: zod.string().describe('Pass as `after` to continue after this row'),
            description: zod.string().nullable(),
            fieldCount: zod
              .int()
              .describe('Schema fields: TYPE→TYPE edges over CONTAINS or INCLUDES'),
            isSystem: zod
              .boolean()
              .describe(
                "One of the platform's system types (the SYSTEM registry), as opposed to a type a person or group authored",
              ),
            kind: zod
              .enum(['complex', 'primitive'])
              .describe(
                'complex when the type has an outgoing CONTAINS or INCLUDES edge (a field, a constant or a template body); a RELATES_TO-only type is primitive',
              ),
            lineageUuid: zod.uuid().describe('UUID v4 identifier'),
            name: zod.string(),
            parentTypeName: zod.string().nullable(),
            parentTypeUuid: zod.uuid().nullable().describe('UUID v4 identifier'),
            typeDefinition: zod
              .object({
                conformance: zod.enum(['open', 'lax', 'strict']).optional(),
                description: zod.string().nullish(),
                enums: zod
                  .array(
                    zod.object({
                      label: zod.string(),
                      value: zod.string(),
                    }),
                  )
                  .nullish(),
                file: zod
                  .object({
                    allowedFormats: zod
                      .array(
                        zod.enum([
                          'pdf',
                          'doc',
                          'docx',
                          'xls',
                          'xlsx',
                          'csv',
                          'txt',
                          'jpeg',
                          'png',
                          'webp',
                          'gif',
                          'heic',
                          'md',
                          'html',
                          'mp3',
                          'm4a',
                          'wav',
                          'mp4',
                          'mov',
                          'webm',
                        ]),
                      )
                      .min(1)
                      .optional(),
                  })
                  .nullish(),
                metadata: zod.record(zod.string(), zod.unknown()).nullish(),
                reference: zod
                  .object({
                    carbonCopy: zod.boolean().optional(),
                    creation: zod.enum(['forbidden', 'optional', 'required']).optional(),
                    edgeType: zod.enum(['INCLUDES', 'RELATES_TO']).optional(),
                    typeLineageUuid: zod.uuid(),
                    typeUuid: zod.uuid(),
                    view: zod
                      .object({
                        predicates: zod
                          .array(
                            zod.object({
                              op: zod.enum(['exists', 'eq', 'contains', 'gte', 'lte']),
                              pathTypeUuids: zod
                                .array(zod.uuid())
                                .min(1)
                                .max(
                                  searchContentResponseDataContentSearchHitsItemOneTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax,
                                ),
                              value: zod.string().optional(),
                              valueType: zod
                                .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
                                .optional(),
                            }),
                          )
                          .max(
                            searchContentResponseDataContentSearchHitsItemOneTypeDefinitionReferenceViewPredicatesMax,
                          )
                          .optional(),
                        searchTerms: zod
                          .array(
                            zod
                              .string()
                              .min(1)
                              .max(
                                searchContentResponseDataContentSearchHitsItemOneTypeDefinitionReferenceViewSearchTermsItemMax,
                              ),
                          )
                          .max(
                            searchContentResponseDataContentSearchHitsItemOneTypeDefinitionReferenceViewSearchTermsMax,
                          )
                          .optional(),
                      })
                      .nullish(),
                  })
                  .nullish(),
                signature: zod.looseObject({}).nullish(),
              })
              .nullable()
              .describe(
                'Stored TYPE configuration: description, arbitrary metadata, ENUM value\/label pairs, and the reference \/ file \/ signature field bags.',
              ),
            updatedAt: zod.string(),
            uuid: zod.uuid().describe('UUID v4 identifier'),
            valueType: zod.string().nullable(),
            variant: zod.enum(['TYPE']),
            viewerPermissions: zod
              .array(zod.enum(['READ', 'SHARE', 'COPY', 'CONTRIBUTE', 'EDIT', 'DELETE']))
              .describe(
                'What the acting principal may do to this type: READ, plus each write permission the write paths would grant it (for showing Edit, Delete or Share). Evaluated for the performAs context, so a group-authored type shows EDIT to its admin only under performAs GROUP.',
              ),
          }),
          zod.object({
            contentTypeUuid: zod.uuid().describe('UUID v4 identifier'),
            cursor: zod.string().describe('Pass as `after` to continue after this row'),
            lineageUuid: zod.uuid().describe('UUID v4 identifier'),
            occurredAt: zod.string(),
            updatedAt: zod.string(),
            uuid: zod.uuid().describe('UUID v4 identifier'),
            variant: zod.enum(['INSTANCE']),
          }),
        ]),
      ),
      pageInfo: zod.object({
        endCursor: zod.string().nullable(),
        hasNextPage: zod.boolean(),
        hasPreviousPage: zod.boolean(),
        startCursor: zod.string().nullable(),
      }),
      partial: zod
        .boolean()
        .optional()
        .describe(
          'Set when the search spans regions: true when a region did not answer in time and its rows are missing from this page and, for pages reached with its cursor, from the rest of this search. Start again from the first page to ask it again.',
        ),
      rootContentUuids: zod.array(zod.uuid()),
      totalCount: zod
        .int()
        .nullable()
        .describe(
          'Size of the whole result on a first page; null on a page reached with `after` (not counted, never zero). Across regions, the sum of the regions’ counts, less the other regions’ copies of reference rows seen.',
        ),
      totalCountIsLowerBound: zod
        .boolean()
        .optional()
        .describe(
          'Set when the search spans regions: true when totalCount leaves out a region that did not answer.',
        ),
      unavailableRegions: zod
        .array(zod.string())
        .optional()
        .describe(
          'Set when the search spans regions: the regions whose rows are missing (empty when none is).',
        ),
    }),
  }),
});

export type SearchContentResponse = zod.input<typeof SearchContentResponse>;
export type SearchContentResponseOutput = zod.output<typeof SearchContentResponse>;
